module.exports = __webpack_public_path__ + "assets/discount_flower-5ee4e4.svg";